// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Oi","title":"Pi","nav":"Qi","flexCell":"Ri","facetLink":"Si"};